import { Box, Center, Flex, Image, Text, useMediaQuery } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'gatsby';
import Container from '../Container/Container';
import Icon from '../Icon/Icon';

const SimpleHeader = () => {
  const [isPc] = useMediaQuery('(min-width: 800px)', {
    ssr: true,
    fallback: false
  });
  return (
    <Box bg={'#1A6179'} py={6} color={'white'}>
      <Container size={'large'}>
        <Flex justify={'space-between'} align={'center'}>
          <Center as={Link} to="/" color={'white'} gap={2} className="underline">
            <Icon symbol={'chevLeft'} />
            {isPc ? <Text fontWeight={500}>Continue Shopping</Text> : <Text>Shop</Text>}
          </Center>
          <Link to="/">
            <Image m={0} maxW={167} src={'/logo2.png'} alt={'logo'} />
          </Link>
          {isPc ? (
            <Center as={Link} color={'white'} gap={2}>
              <Icon symbol={'lock'} />
              <Text fontSize={'21px'} fontWeight={'bold'}>
                Secure checkout
              </Text>
            </Center>
          ) : (
            <Text></Text>
          )}
        </Flex>
      </Container>
    </Box>
  );
};

export default SimpleHeader;
